export const disputeTooltipText = `When your business receives a dispute (also called a chargeback),
the payment amount as well as a separate dispute fee levied by the card
network will be deducted from your account balance.`;
